module.exports = __webpack_public_path__ + "static/media/contact-image0.185f9d8a.jpg";